




























































import Vue, { PropOptions } from 'vue';
import {NOC, moment} from '@/class';
import Calender, {ICalenderDate} from '@/components/util/Calender.vue';
import { CCustomHoliday } from '@/class/models/typed/custom-holiday';

// validation
import * as validation from '@/personal/validation';
import VariableInput, {IVariableInput, INPUT_TYPE} from '@/components/util/VariableInput.vue';

import JsDatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';

export default Vue.extend({
  name: 'DatePicker',
  components: { Calender, VariableInput, JsDatePicker },
  props: {
    // allCustomHoliday: Array as PropOptions<CCustomHoliday>,
    editCustomHolidayIndex: Number,
    customHolidayData: {
      type: Object,
      default: () => (new CCustomHoliday()),
    },
    deleteButton: {
      type: Boolean,
      default: true,
    },
    newHolidayFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customHoliday: new CCustomHoliday(),
      calender: false,
      items: [
        {key: 'name', name: 'カスタム休日名', placeholder: '入力してください', required: true, checks: [], error: '', max: 15},
        {key: 'date', name: '指定年月日', placeholder: '年/月/日', type: INPUT_TYPE.DATE, required: true, error: '', checks: [validation.CHECK_TYPE.DATE]},
        {key: 'description', name: 'カスタム休日の説明', placeholder: 'この休日の説明', required: false, checks: [], error: '', max: 200},
      ] as validation.IPValidation[],
      DatePickerDate: 'yyyy/MM/dd',
      ja,
    };
  },
  directives: {
    JsDatePicker,
  },
  mounted() {
    this.customHoliday = this.customHolidayData;
    if (this.newHolidayFlag === true) {
      this.customHoliday.date = '';
    } else {
      this.customHoliday.date = moment.fncChangeDateToInputForm(new Date(this.customHolidayData.date));
    }
    // console.log(this.customHolidayData.date);
    // console.log(this.newHolidayFlag);
  },
  methods: {
    // カレンダー選択時処理
    onSelectDate(calenderDate: ICalenderDate) {
      // this.customHoliday.date = calenderDate.year + '/' + calenderDate.month + '/' + calenderDate.date;
      this.calender = false;
      this.customHoliday.date = moment.fncChangeDateToInputForm(new Date(this.customHolidayData.date));
      // console.log(this.customHoliday.date);
    },
    // 登録ボタン押下時処理
    onClickRegister() {
      // validation
      if (validation.checkValues(this.customHoliday, this.items) > 0) {
        return;
      }
      this.$emit('register', this.customHoliday);
    },
    // 削除ボタン押下時処理
    onClickDelete() {
      this.$emit('delete', this.customHoliday);
    },
    onClickCancel() {
      this.customHoliday = new CCustomHoliday();
      this.$emit('cancel');
    },
    onChangeValue(value: string, item: validation.IPValidation) {
      validation.checkValue(value, item);
    },
  },
});
